export default __webpack_public_path__ + "b3bd2a5f3ff5ab3d5677d3f9ad4e7aad.png";